import React, { Component } from 'react';
import { Row, Col } from "antd";
import {
    
    AccessModal,
    AccessTable,
    TableHeading,
    TableLastHeading,
    TableData,
    TableLastData,
    TableRow,
    BlueCircle,
    GreenCircle,
    MixedCircle,
    LightGreenCircle,
    CloseButton,
    WhiteAccessCard,
    GreyAccessCard,
    MobileBlueCircle,
    MixedMobileCircle,
    MobileGreenCircle,
    MobileLightGreenCircle,
    TableColumnHeading,
    TableHeadingFirst,
    TableHeadingSecond,
    TableHeadingLimited,
    ModalClose,
    TableDescription,
    Mixedindex,
    AccessTableWrapper
  } from "./styles";
  import {
    DataHeading,
    DataValue,
    SemiDarkerDivider,
    DisplayFlex
  } from "../../../../CommonComponents/commonStyles";
  import {
    ContentMessage,
    Types
  } from "../../../../CommonComponents/ContentMessages";
  import PropTypes from 'prop-types';
import { GeneralButton } from '../../../../CommonComponents/Commons/commonComponents';

  const ModalTitle = () => <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Access Modal" property="field_modal_content_title" defaultMessage="Compare interested party roles"/>
export default class SharedAccessModal extends Component {

    render() {
        return (
            <AccessModal
                className="accessModalTitle"
                title={ <ModalTitle /> }
                centered
                onOk={() => this.props.setModalVisible(false)}
                onCancel={() => this.props.setModalVisible(false)}
                visible={this.props.modalVisible}
                footer={[
                    <GeneralButton
                        id="btnAccessLevelCancel"
                        onClick={() => this.props.setModalVisible(false)}
                        text="Close"
                        type="functional"
                        width="150px"
                        mobWidth="150px"
                        styling='my0 mx-auto'
                    >
                    </GeneralButton>
                ]}
            >
                <ModalClose id="btnAccessLevelIcon" onClick={() => this.props.setModalVisible(false)}>
                    <span className='closeBtn'/>
                </ModalClose>
                <AccessTableWrapper className="tableAccessWrapper" lg={24} md={24} xs={0}>
                    
                    <AccessTable>
                        <TableRow>
                            <TableHeading>
                                <DataValue />
                            </TableHeading>
                            <TableHeadingFirst>
                                <TableColumnHeading>Full</TableColumnHeading>
                            </TableHeadingFirst>
                            <TableHeadingLimited>
                                <TableColumnHeading>Read-only + Exchange</TableColumnHeading>
                            </TableHeadingLimited>
                            <TableHeadingSecond>
                                <TableColumnHeading>Read-only</TableColumnHeading>
                            </TableHeadingSecond>
                            <TableLastHeading>Paper Statement</TableLastHeading>
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_1_descriptn" defaultMessage="Receive paper quarterly statements only"/>
                            </TableDescription>
                            <TableData />
                            <TableData />
                            <TableData />
                            <TableLastData>
                                <LightGreenCircle />
                            </TableLastData>
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_2_descriptn" defaultMessage="Receive paper or online quarterly statements depending on delivery preference"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData>
                                <MixedCircle />
                            </TableData>
                            <TableData>
                                <GreenCircle />
                            </TableData>
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_3_descriptn" defaultMessage="Request account information such as balance, transaction status, and history"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData>
                                <MixedCircle />
                            </TableData>
                            <TableData>
                                <GreenCircle />
                            </TableData>
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_4_descriptn" defaultMessage="View account information and statements online"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData>
                                <MixedCircle />
                            </TableData>
                            <TableData>
                                <GreenCircle />
                            </TableData>
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_5_descriptn" defaultMessage="Reset individual password online"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData>
                                <MixedCircle />
                            </TableData>
                            <TableData>
                                <GreenCircle />
                            </TableData>
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_6_descriptn" defaultMessage="Select a delivery preference (electronic or paper) for communications"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData>
                                <MixedCircle />
                            </TableData>
                            <TableData>
                                <GreenCircle />
                            </TableData>
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_7_descriptn" defaultMessage="Edit personal contact information online"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData>
                                <MixedCircle />
                            </TableData>
                            <TableData>
                                <GreenCircle />
                            </TableData>
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_8_descriptn" defaultMessage="Recommend exchanges online or over the phone "/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData>
                                <MixedCircle />
                            </TableData>
                            <TableData />
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_9_descriptn" defaultMessage="Recommend grants online or with a paper form"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData />
                            <TableData />
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_10_descriptn" defaultMessage="Request address changes for account advisors"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData />
                            <TableData />
                            <TableLastData />
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_11_descriptn" defaultMessage="View/receive confirmations of contributions, grants, exchanges and other account activity, if designated as the primary contact on the account"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData />
                            <TableData />
                            <TableLastData />
                        </TableRow> 

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_12_descriptn" defaultMessage="Request changes to the account name, advisors, or succession plan"/>
                            </TableDescription>
                            <TableData>
                            <center>n/a</center> 
                            </TableData>
                            <TableData>
                            <center>n/a</center> 
                            </TableData>
                            <TableData>
                            <center>n/a</center> 
                            </TableData>
                            <TableLastData>
                            <center>n/a</center> 
                            </TableLastData>
                        </TableRow>

                        <TableRow>
                            <TableDescription>                                
                                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_13_descriptn" defaultMessage="Link their own Vanguard and  Vanguard Charitables accounts"/>
                            </TableDescription>
                            <TableData>
                                <BlueCircle />
                            </TableData>
                            <TableData>
                                <MixedCircle />
                            </TableData>
                            <TableData>
                                <GreenCircle />
                            </TableData>
                            <TableLastData />
                        </TableRow> 

                    </AccessTable>
                </AccessTableWrapper>
                <Col lg={0} md={0} xs={24}>
                    <SemiDarkerDivider className="my0" />
                    <GreyAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_1_descriptn" defaultMessage="Receive paper quarterly statements only"/>
                        </DataValue>
                        <Row>
                           
                                <DisplayFlex center>
                                    <MobileLightGreenCircle>P</MobileLightGreenCircle>
                                    <DataHeading className="mt-03 ml1">Paper 
Statement</DataHeading>
                                </DisplayFlex>
                        </Row>
                    </GreyAccessCard>

                    <WhiteAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_2_descriptn" defaultMessage="Receive paper or online quarterly statements depending on delivery preference"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12} className="mt-3">
                                <DisplayFlex center>
                                    <MixedMobileCircle>
                                        <Mixedindex>E</Mixedindex>
                                    </MixedMobileCircle>
                                    <DataHeading className="mt-03 ml1 lh16">
                                        Read-only + 
Exchange
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12} className="mt2">
                                <DisplayFlex center>
                                    <MobileGreenCircle>R</MobileGreenCircle>
                                    <DataHeading className="mt-03 ml1">Read-only</DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </WhiteAccessCard>

                    <GreyAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_3_descriptn" defaultMessage="Request account information such as balance, transaction status, and history"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MixedMobileCircle>
                                        <Mixedindex>E</Mixedindex>
                                    </MixedMobileCircle>
                                    <DataHeading className="mt-03 ml1 lh16">
                                        Read-only + 
Exchange
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12} className="mt2">
                                <DisplayFlex center>
                                    <MobileGreenCircle>R</MobileGreenCircle>
                                    <DataHeading className="mt-03 ml1">Read-only</DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </GreyAccessCard>

                    <WhiteAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_4_descriptn" defaultMessage="View account information and statements online"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MixedMobileCircle>
                                        <Mixedindex>E</Mixedindex>
                                    </MixedMobileCircle>
                                    <DataHeading className="mt-03 ml1 lh16">
                                        Read-only + 
Exchange
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12} className="mt2">
                                <DisplayFlex center>
                                    <MobileGreenCircle>R</MobileGreenCircle>
                                    <DataHeading className="mt-03 ml1">Read-only</DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </WhiteAccessCard>

                    <GreyAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_5_descriptn" defaultMessage="Reset individual password online"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MixedMobileCircle>
                                        <Mixedindex>E</Mixedindex>
                                    </MixedMobileCircle>
                                    <DataHeading className="mt-03 ml1 lh16">
                                        Read-only + 
Exchange
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12} className="mt2">
                                <DisplayFlex center>
                                    <MobileGreenCircle>R</MobileGreenCircle>
                                    <DataHeading className="mt-03 ml1">Read-only</DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </GreyAccessCard>

                    <WhiteAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_6_descriptn" defaultMessage="Select a delivery preference (electronic or paper) for communications"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MixedMobileCircle>
                                        <Mixedindex>E</Mixedindex>
                                    </MixedMobileCircle>
                                    <DataHeading className="mt-03 ml1 lh16">
                                        Read-only + 
Exchange
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12} className="mt2">
                                <DisplayFlex center>
                                    <MobileGreenCircle>R</MobileGreenCircle>
                                    <DataHeading className="mt-03 ml1">Read-only</DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </WhiteAccessCard>

                    <GreyAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_7_descriptn" defaultMessage="Edit personal contact information online"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MixedMobileCircle>
                                        <Mixedindex>E</Mixedindex>
                                    </MixedMobileCircle>
                                    <DataHeading className="mt-03 ml1 lh16">
                                        Read-only + 
Exchange
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12} className="mt2">
                                <DisplayFlex center>
                                    <MobileGreenCircle>R</MobileGreenCircle>
                                    <DataHeading className="mt-03 ml1">Read-only</DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </GreyAccessCard>
                    
                    <WhiteAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_8_descriptn" defaultMessage="Recommend exchanges online or over the phone"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MixedMobileCircle>
                                        <Mixedindex>E</Mixedindex>
                                    </MixedMobileCircle>
                                    <DataHeading className="mt-03 ml1 lh16">
                                        Read-only + 
Exchange
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </WhiteAccessCard>
                    <GreyAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_9_descriptn" defaultMessage="field_modal_content_9_descriptn" defaultMessage="Recommend grants online or with a paper form"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            
                        </Row>
                    </GreyAccessCard>
                    <WhiteAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_10_descriptn" defaultMessage="Request address changes for account advisors"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </WhiteAccessCard>

                    <GreyAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_11_descriptn" defaultMessage="View/receive confirmations of contributions, grants, exchanges and other account activity, if designated as the primary contact on the account"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </GreyAccessCard>
                    <WhiteAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_12_descriptn" defaultMessage="Request changes to the account name, advisors, or succession plan"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                   
                                    <DataHeading className="mt-03 ml1">
                                        n/a
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </WhiteAccessCard>
                    <GreyAccessCard>
                        <DataValue className="mt0 mb2">
                        <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Access Modal" property="field_modal_content_13_descriptn" defaultMessage="Link their own Vanguard and Vanguard Charitables accounts"/>
                        </DataValue>
                        <Row>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MobileBlueCircle>F</MobileBlueCircle>
                                    <DataHeading className="mt-03 ml1">
                                        Full Access
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12}>
                                <DisplayFlex center>
                                    <MixedMobileCircle>
                                        <Mixedindex>E</Mixedindex>
                                    </MixedMobileCircle>
                                    <DataHeading className="mt-03 ml1 lh16">
                                        Read-only + 
Exchange
                                    </DataHeading>
                                </DisplayFlex>
                            </Col>
                            <Col xs={12} className = "mt2">
                                <DisplayFlex center>
                                    <MobileGreenCircle>R</MobileGreenCircle>
                                    <DataHeading className="mt-03 ml1">Read-only</DataHeading>
                                </DisplayFlex>
                            </Col>
                        </Row>
                    </GreyAccessCard>

                </Col>
            </AccessModal>
        )
    }
}

SharedAccessModal.propTypes = {
    setModalVisible: PropTypes.func.isRequired,
    modalVisible: PropTypes.bool.isRequired
}